<template>
  <div class="wrapper">
    <edit-modal
      v-if="showEditItem"
      :comboInfo="comboInfo"
      :singleItem="selectedItem"
      @closeModal="closeModal"
      @payOnEdit="$emit('payOnEdit')"
    />
    <confirm-modal
      v-if="showConfirmModal"
      :header="$t('order.remove_item_header')"
      :title="$t('order.remove_item_title')"
      @onConfirm="confirmedRemove"
      @onClose="turnConfirmModal"
    />
    <select-extra
      v-if="showEditExtra"
      :product="editExtraItem"
      @onConfirm="doneEditExtra"
      @onClose="cancelEditExtra"
    />
    <div class="orderList container">
      <div
        :class="{ removeAnim: removalAnimations.find(uid => uid === item.uid) }"
        class="orderListItem"
        :key="item.uid"
        v-for="item in basket"
      >
        <ProductItem
          v-if="!item.selectedCombo"
          :item="item"
          @add="changeCount(item, 'plus')"
          @sub="changeCount(item, 'minus')"
          @del="showConfirmRemove(item)"
          @edit="editSingleItem(item)"
          @editExtra="editExtra"
        ></ProductItem>
        <MenuItem
          v-else
          :menu="item"
          @add="changeCount(item, 'plus')"
          @sub="changeCount(item, 'minus')"
          @del="showConfirmRemove(item)"
          @editExtra="editExtra"
          @edit="editMenuComponent"
        ></MenuItem>
      </div>
      <div :key="coupon.ticket" v-for="coupon in coupons">
        <CouponItem :coupon="coupon"></CouponItem>
      </div>
    </div>
    <div class="gradient"></div>
    <div class="gradient-top"></div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import EditModal from "@/components/modals/edit.vue";
import ConfirmModal from "@/components/modals/confirm.vue";
import {
  combineProductsToMenu,
  findSameBasketItem,
  updateExactProductInBasket
} from "@/utils/products";

import {
  isCombo,
  productPrice,
  toCalculatable,
  toPrintable
} from "@/utils/pricing";
import SelectExtra from "../modals/selectExtra";
import ProductItem from "./listItems/ProductItem";
import MenuItem from "./listItems/MenuItem";
import CouponItem from "./listItems/CouponItem";

export default {
  components: {
    CouponItem,
    ProductItem,
    MenuItem,
    SelectExtra,
    EditModal,
    ConfirmModal
  },
  props: {
    noprices: Boolean
  },
  computed: {
    ...mapGetters({
      basket: "BASKET",
      coupons: "COUPONS",
      project: "PROJECT",
      menus: "MENUS"
    })
  },
  data() {
    return {
      collapsed: {},
      item: {},
      editExtraItem: {},
      showEditItem: false,
      showEditExtra: false,
      showEditSize: false,
      showConfirmModal: false,
      itemForRemove: {},
      isCombo: false,
      comboInfo: {},
      selectedItem: {},
      removalAnimations: []
    };
  },
  created() {
    this.basket.forEach(item => {
      this.$set(this.collapsed, item.id, !item.selectedCombo);
      let offsetPrice = 0.0;
      if (item.components) {
        item.components.forEach(com => {
          if (com.selected) {
            offsetPrice += Number(com.selected.menu_offset_price);
          }
        });
      }
      // check use_price_in_menu here for sum of offsetPrice???
      console.log("offsetPrice " + offsetPrice);
      this.$set(item, "offsetPrice", offsetPrice);
    });
  },
  methods: {
    toPrintable,
    toCalculatable,
    productPrice,
    turnConfirmModal() {
      this.showConfirmModal = !this.showConfirmModal;
      this.itemForRemove = {};
    },
    editSingleItem(item) {
      this.selectedItem = item;
      this.isCombo = false;
      this.comboInfo = {};
      this.showEditItem = !this.showEditItem;
    },
    editMenuComponent({ item, uid, component_id }) {
      //name is component.name
      this.selectedItem = item;
      this.isCombo = true;
      this.comboInfo = { comboUID: uid, component_id };
      this.showEditItem = !this.showEditItem;
    },
    editExtra({ item, extra }) {
      const tmp_basket_item = { ...item };
      tmp_basket_item.selectedExtras = item.selectedExtras.filter(
        e => e.extra_category_id !== extra.extra_category_id
      );
      this.editExtraItem = tmp_basket_item;
      this.showEditExtra = true;
    },
    doneEditExtra(extras) {
      this.showEditExtra = false;
      this.editExtraItem.selectedExtras = extras;
      let newBasket = updateExactProductInBasket(
        this.editExtraItem,
        this.basket
      );
      let updated_bi = newBasket.find(
        el =>
          el.uid === this.editExtraItem.uid ||
          (isCombo(el) &&
            el.components.find(
              c => c.selected.uid === this.editExtraItem.uid
            ) !== undefined)
      );
      const newBasketWithoutEdited = newBasket.filter(
        el => el.uid !== updated_bi.uid
      );
      let existing = findSameBasketItem(updated_bi, newBasketWithoutEdited);
      if (existing) {
        newBasket = newBasketWithoutEdited;
        newBasket = newBasket.map(bi =>
          bi.uid === existing.uid
            ? { ...existing, count: existing.count + updated_bi.count }
            : bi
        );
      }
      this.setBasket(newBasket);
      this.editExtraItem = {};
    },
    cancelEditExtra() {
      this.showEditExtra = false;
      this.editExtraItem = {};
    },
    closeModal() {
      this.selectedItem = {};
      this.showEditItem = !this.showEditItem;
      this.isCombo = false;
    },
    changeCount(basketItem, action) {
      switch (action) {
        case "plus":
          this.logAudit({
            category: "CART",
            event: "ADD_PRODUCT",
            data: basketItem
          });
          basketItem.count += 1;
          if (isCombo(basketItem)) {
            basketItem.automatically_generated = false;
          }
          break;
        case "minus":
          this.logAudit({
            category: "CART",
            event: "REMOVE_PRODUCT",
            data: basketItem
          });
          if (basketItem.count > 1) {
            basketItem.count -= 1;
          } else {
            this.showConfirmRemove(basketItem);
            return;
          }
          break;
      }
      let newBasket = this.basket.map(bi => {
        return { ...bi };
      });
      newBasket = combineProductsToMenu(this.menus, this.basket);
      this.setBasket(newBasket);
    },
    showConfirmRemove(item) {
      this.turnConfirmModal();
      this.itemForRemove = item;
    },
    confirmedRemove() {
      this.removeFromBasket(this.itemForRemove);
      this.turnConfirmModal();
    },
    animateRemoval(uid) {
      this.removalAnimations.push(uid);
      setTimeout(() => {
        this.removalAnimations = this.removalAnimations.filter(
          anim_uid => anim_uid !== uid
        );
      }, 500);
    },
    removeFromBasket(basketItem, really = false) {
      let item_to_remove = this.basket.find(el => el.uid === basketItem.uid);
      if (
        !really &&
        !this.removalAnimations.find(uid => uid === item_to_remove.uid)
      ) {
        this.animateRemoval(item_to_remove.uid);
        setTimeout(() => {
          this.removeFromBasket(basketItem, true);
        }, 500);
        return;
      }
      this.logAudit({
        category: "CART",
        event: "REMOVE_PRODUCT",
        data: item_to_remove
      });
      const basket = this.basket.filter(el => el.uid !== item_to_remove.uid);
      this.setBasket(basket);
      if (basket.length === 0) {
        this.logRouter({ name: "menu", router: this.$router });
      }
    },
    ...mapMutations({
      setBasket: "SET_BASKET"
    }),
    ...mapActions({ logRouter: "LOG_ROUTER", logAudit: "LOG_AUDIT" })
  }
};
</script>
<style lang="scss">
.editRemoveBlock {
  display: flex;
  align-items: center;
  pointer-events: none;
  position: absolute;
  bottom: 15px;
  right: 20px;
}
</style>
<style lang="scss" scoped>
.orderList {
  width: 100%;
  height: fit-content;
  max-height: 1000px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  overflow: scroll;
  padding: 40px 0 80px;
  transition: height 0.5s ease;
}

.wrapper {
  overflow: hidden;
  padding-bottom: 3px;
}

.gradient {
  pointer-events: none;
  height: 80px;
  background: var(--component_OrderList_gradient_background);
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100;
}

.gradient-top {
  pointer-events: none;
  height: 40px;
  background: var(--component_OrderList_gradient_background);
  transform: scaleY(-1);
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
}

.itemBox {
  background: var(--component_OrderList_itemBox_background);
  border: var(--component_OrderList_itemBox_border);
  border-radius: var(--component_OrderList_itemBox_border-radius);
  box-shadow: var(--component_OrderList_itemBox_box-shadow);
  padding: 20px 20px 15px 10px;
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  position: relative;
}

.removeAnim {
  transition: all 0.5s;
  height: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
  min-height: 0;
  transform: scaleY(0.01) scaleX(0.01);
}

.removeAnim .itemBox {
  margin-top: 0;
}
</style>
